import {ShowPageScopeCollector} from "@frontend/group/modules/scope-collectors/show-page-collector";
import store from "@frontend/store";
import {removeAllElementParamsAndChanges} from "@/common/preview/remove-all-element-params-and-changes";
import AdditionalFieldService from '@frontend/services/api/additional-field';

const getShowPageScope = () => ShowPageScopeCollector.get([
  'updateLayoutChanges',
  'canvas_data',
  'reorderObjectCanvas'
]);

const ADDITIONAL_BACKGROUND_THEME_IMAGE_FIELDS = [
  'add_bk_img_angle',
  'add_bk_img_duplicate_data',
  'add_bk_img_flipX',
  'add_bk_img_flipY',
  'add_bk_img_height',
  'add_bk_img_is_mirror',
  'add_bk_img_masks',
  'add_bk_img_mirror_coords',
  'add_bk_img_mirror_delete_source',
  'add_bk_img_mirror_distance',
  'add_bk_img_mirror_fade',
  'add_bk_img_mirror_position',
  'add_bk_img_mirror_skew',
  'add_bk_img_offset_x',
  'add_bk_img_offset_y',
  'add_bk_img_opacity',
  'add_bk_img_order',
  'add_bk_img_scale',
  'add_bk_img_scale_y',
  'add_bk_img_shadow',
  'add_bk_img_width',
  'add_bk_img_object_fit',
  'add_bk_img_object_fill',
  'additional_background_images',
  'add_bk_img_is_another_instance',
  'add_bk_img_is_shifted', 
  'add_bk_img_visible'
]

export const deleteAdditionalBackgroundThemeImageField = (fabricItemInstance) => {
  const { canvas_data, updateLayoutChanges } = getShowPageScope()
  const instanceId = fabricItemInstance.canvas.instance_id;

  const currentData = canvas_data[instanceId]._data
  let match = fabricItemInstance.element_id.match(/\d+/);
  
  // extract the index from the element_id 
  const index = match ? parseInt(match[0], 10) : null;
  
  for (const key of ADDITIONAL_BACKGROUND_THEME_IMAGE_FIELDS) {
    if (!Array.isArray(currentData[key])) {
      continue; // Skip this key
    }
    const deletedItem = currentData[key].splice(index, 1)

    // I don't think this is neccesary anymore
    if (key === 'add_bk_img_order') {
      let prev = deletedItem
      for (const i in currentData[key]) {
        if (i >= index) {
          let temp = currentData[key][i]
          currentData[key][i] = prev
          prev = temp
        }
      }
    }

    updateLayoutChanges(instanceId, key, currentData[key])
  }

  // drop the deleted slot from the coords array. The array is sparse (slots without
  // an image never get an entry in setAdditionalBackgroundImage), so a manual
  // element-by-element shift would read `undefined[...]` and throw
  if (Array.isArray(canvas_data[instanceId].additionalBkImgCoords)) {
    canvas_data[instanceId].additionalBkImgCoords.splice(index, 1);
  }

  store.commit('layout/DELETE_LAYER', fabricItemInstance.element_id)
  const canvas = fabricItemInstance.canvas

  canvas.forEachObject(function(object) {
    if (object.element_id == fabricItemInstance.element_id) {
      canvas.remove(object);
    }else 
    // re-arrange the elements id's on the canvas
    if (object.element_id && object.element_id.startsWith("additional-")) {
      match = object.element_id.match(/\d+/);
      const index2 = match ? parseInt(match[0], 10) : null;
      if (index2 > index){
        object.element_id = "additional-"+ (index2 -1);
        object.id = "add_bk_theme_img_" + (index2 -1);
      }
    } 
  })
}

export async function deleteAdditionalTextField(
  selectedTextObj,
  instanceId,
  previews,
  canvas_data,
  drawAdditionalText,
  canvas,
  drawAdditionalMultiLineText,
  btnSaveChanges,
  disableBtnSave = false
) {
  const { reorderObjectCanvas } = getShowPageScope();
  
  const payload = {
    fieldKey: selectedTextObj.element_id,
    instance_id: instanceId
  };

  const preview = previews.find(({id}) => id === instanceId);
  const customerId = preview.template.customer_id;
  const layoutId = $("#template-group-preview").attr("data-layout-id");
  canvas_data[instanceId].additionalMultiLineTexts = canvas_data[instanceId].additionalMultiLineTexts.filter(field => field !== selectedTextObj.element_id);
  canvas_data[instanceId].additionalTexts = canvas_data[instanceId].additionalTexts.filter(field => field !== selectedTextObj.element_id);
  
  await AdditionalFieldService.deleteField(customerId, layoutId, payload)

  removeAllElementParamsAndChanges(canvas.instance_id, selectedTextObj.element_id);

  await drawAdditionalText({
    fields: null,
    data: null,
    canvas,
    id: instanceId,
    group_fields: null,
    dimension: null,
  });
  await drawAdditionalMultiLineText({canvas, id: instanceId});

  reorderObjectCanvas(canvas);

  if (!disableBtnSave) {
    if (!btnSaveChanges) {
      btnSaveChanges = $('.btn-save-changes');
    }
    btnSaveChanges.click();
  }
}
